import { apiClient } from '@/api/client';
import type { Paginated, ReviewCategory, ReviewCategoryGroup, ReviewEvent, Reviews, ReviewSubmit, ScanDetail, ScanSummary } from '@/types';

export async function listScans(admin: boolean, page: number, dateFrom?: string, dateTo?: string) {
  const { data } = await apiClient.get<Paginated<ScanSummary>>(admin ? '/admin/inferences' : '/inferences', {
    params: { page, page_size: 20, date_from: dateFrom || undefined, date_to: dateTo || undefined, include_thumbnails: true },
  });
  return data;
}
export async function getScan(id: string, admin: boolean) {
  const { data } = await apiClient.get<ScanDetail>(`${admin ? '/admin/inferences' : '/inferences'}/${id}`);
  return data;
}
export async function getReviews(id: string) {
  const { data } = await apiClient.get<Reviews>(`/inferences/${id}/reviews`);
  return data;
}
export async function submitReview(id: string, payload: ReviewSubmit) {
  const { data } = await apiClient.post<ReviewEvent>(`/inferences/${id}/reviews`, payload);
  return data;
}
export async function listGroups() {
  const { data } = await apiClient.get<{ items: ReviewCategoryGroup[] }>('/review-category-groups');
  return data.items;
}
export async function listCategories() {
  const { data } = await apiClient.get<{ items: ReviewCategory[] }>('/review-categories');
  return data.items;
}
export async function createGroup(payload: { code: string; name: string }) {
  const { data } = await apiClient.post<ReviewCategoryGroup>('/admin/review-category-groups', payload);
  return data;
}
export async function createCategory(payload: { group_id: string; code: string; name: string }) {
  const { data } = await apiClient.post<ReviewCategory>('/admin/review-categories', payload);
  return data;
}
export async function setGroupActive(id: string, is_active: boolean) {
  const { data } = await apiClient.patch<ReviewCategoryGroup>(`/admin/review-category-groups/${id}`, { is_active });
  return data;
}
export async function setCategoryActive(id: string, is_active: boolean) {
  const { data } = await apiClient.patch<ReviewCategory>(`/admin/review-categories/${id}`, { is_active });
  return data;
}
export async function deleteGroup(id: string) {
  await apiClient.delete(`/admin/review-category-groups/${id}`);
}
export async function deleteCategory(id: string) {
  await apiClient.delete(`/admin/review-categories/${id}`);
}
